export default "__VITE_ASSET__CvqM0LuG__"